(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floyd-featured-collections-hover"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floyd-hover-video')) {
    class FloydHoverVideo extends HTMLElement {
      connectedCallback() {
        this.trigger = this.closest('.product-card__figure');
        this.video = null;
        this.isActive = false;
        this.retryScheduled = false;

        const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        const reducesMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.trigger || !supportsHover || reducesMotion) return;

        this.onPointerEnter = () => this.activate();
        this.onPointerLeave = () => this.deactivate();
        this.onFocusIn = () => this.activate();
        this.onFocusOut = (event) => {
          if (!this.trigger.contains(event.relatedTarget)) this.deactivate();
        };

        this.trigger.addEventListener('pointerenter', this.onPointerEnter);
        this.trigger.addEventListener('pointerleave', this.onPointerLeave);
        this.trigger.addEventListener('focusin', this.onFocusIn);
        this.trigger.addEventListener('focusout', this.onFocusOut);
      }

      disconnectedCallback() {
        if (!this.trigger) return;

        this.trigger.removeEventListener('pointerenter', this.onPointerEnter);
        this.trigger.removeEventListener('pointerleave', this.onPointerLeave);
        this.trigger.removeEventListener('focusin', this.onFocusIn);
        this.trigger.removeEventListener('focusout', this.onFocusOut);

        if (this.video) {
          this.video.removeEventListener('playing', this.onPlaying);
          this.video.removeEventListener('error', this.onVideoError);
        }
      }

      activate() {
        this.isActive = true;
        const video = this.hydrate();
        if (!video) return;

        if (video.error || this.hasAttribute('data-load-error')) {
          this.removeAttribute('data-load-error');
          video.load();
        }

        this.playVideo(video, true);
      }

      playVideo(video, allowRetry) {
        const playPromise = video.play();
        if (playPromise) {
          playPromise.then(() => {
            if (!this.isActive) video.pause();
          }).catch(() => {
            if (!this.isActive || !allowRetry || this.retryScheduled) return;

            this.retryScheduled = true;
            video.load();

            requestAnimationFrame(() => {
              this.retryScheduled = false;
              if (this.isActive) this.playVideo(video, false);
            });
          });
        }
      }

      deactivate() {
        this.isActive = false;
        if (this.video) this.video.pause();
      }

      hydrate() {
        if (this.video) return this.video;

        const template = this.querySelector('template');
        if (!template) return null;

        this.appendChild(template.content.cloneNode(true));
        template.remove();
        this.video = this.querySelector('video');

        if (this.video) {
          this.video.removeAttribute('poster');

          this.onPlaying = () => {
            const revealVideo = () => {
              this.removeAttribute('data-load-error');
              this.setAttribute('data-loaded', '');
            };

            if ('requestVideoFrameCallback' in this.video) {
              this.video.requestVideoFrameCallback(revealVideo);
            } else {
              requestAnimationFrame(() => requestAnimationFrame(revealVideo));
            }
          };

          this.onVideoError = () => {
            this.removeAttribute('data-loaded');
            this.setAttribute('data-load-error', '');
          };

          this.video.addEventListener('playing', this.onPlaying);
          this.video.addEventListener('error', this.onVideoError);
        }

        return this.video;
      }
    }

    customElements.define('floyd-hover-video', FloydHoverVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floyd-video-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.shopify-section--floyd-video-with-text video-media[data-floyd-autoplay] > video';
    const sectionSelector = '.shopify-section--floyd-video-with-text';

    function prefetchActivePoster(section) {
      const activeMedia = [...section.querySelectorAll('video-media[data-floyd-autoplay]')]
        .find(media => getComputedStyle(media).display !== 'none');
      const poster = activeMedia?.querySelector(':scope > img');

      if (!poster) return;

      poster.loading = 'eager';
      poster.setAttribute('fetchpriority', 'low');
    }

    function getViewportIntersectionRatio(element) {
      const rect = element.getBoundingClientRect();
      const visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
      const area = rect.width * rect.height;

      return area > 0 ? (visibleWidth * visibleHeight) / area : 0;
    }

    const autoplayStartTimers = new WeakMap();

    const autoplayObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const media = entry.target;
        const existingTimer = autoplayStartTimers.get(media);

        if (!entry.isIntersecting || getViewportIntersectionRatio(media) < 0.05) {
          if (existingTimer) {
            clearTimeout(existingTimer);
            autoplayStartTimers.delete(media);
          }

          return;
        }

        if (existingTimer) return;

        const timer = setTimeout(() => {
          autoplayStartTimers.delete(media);

          if (getComputedStyle(media).display === 'none' || getViewportIntersectionRatio(media) < 0.05) return;

          media.setAttribute('autoplay', '');
          media.play();
          autoplayObserver.unobserve(media);
        }, 400);

        autoplayStartTimers.set(media, timer);
      });
    }, {threshold: [0, 0.05]});

    function observeAutoplayMedia(root = document) {
      const mediaElements = [];

      if (root instanceof Element && root.matches('video-media[data-floyd-autoplay]')) mediaElements.push(root);
      root.querySelectorAll?.('video-media[data-floyd-autoplay]').forEach(media => mediaElements.push(media));

      mediaElements.forEach(media => {
        if (media.dataset.floydAutoplayObserved === 'true') return;

        media.dataset.floydAutoplayObserved = 'true';
        autoplayObserver.observe(media);
      });
    }

    const posterObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        prefetchActivePoster(entry.target);
        posterObserver.unobserve(entry.target);
      });
    }, {rootMargin: '1200px 0px'});

    function observePosterSections(root = document) {
      const sections = [];

      if (root instanceof Element && root.matches(sectionSelector)) sections.push(root);
      root.querySelectorAll?.(sectionSelector).forEach(section => sections.push(section));
      sections.forEach(section => posterObserver.observe(section));
    }


    function observeAutoplayMediaWhenReady(root = document) {
      let initialized = false;

      const initialize = () => {
        if (initialized) return;

        initialized = true;
        observeAutoplayMedia(root);
      };

      if (document.readyState === 'complete') {
        initialize();
        return;
      }

      window.addEventListener('load', initialize, {once: true});
      window.addEventListener('scroll', initialize, {once: true, passive: true});
    }

    function wireVideo(video) {
      if (video.dataset.floydFirstFrameWired === 'true') return;

      const media = video.closest('video-media');
      if (!media) return;

      video.dataset.floydFirstFrameWired = 'true';

      const revealVideo = () => {
        media.setAttribute('data-floyd-video-ready', '');
        video.removeEventListener('playing', handlePlaying);
      };

      const handlePlaying = () => {
        if (media.hasAttribute('data-floyd-video-ready')) return;

        if ('requestVideoFrameCallback' in video) {
          video.requestVideoFrameCallback(revealVideo);
        } else {
          requestAnimationFrame(() => requestAnimationFrame(revealVideo));
        }
      };

      video.addEventListener('playing', handlePlaying);

      if (!video.paused && video.readyState >= 2) handlePlaying();
    }

    function init(root = document) {
      root.querySelectorAll(selector).forEach(wireVideo);
      observePosterSections(root);
      observeAutoplayMediaWhenReady(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
